<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"
import { useTranslation } from "i18next-vue"
import LocaleSwitcher from "@/components/LocaleSwitcher.vue"
import { home, sessions } from "@/routes"

const { t } = useTranslation()
const page = usePage()
const current = (name: string) => page.component === name
</script>

<template>
  <div class="min-h-screen bg-background text-foreground">
    <nav class="flex items-center justify-between border-b px-6 py-4">
      <div class="flex gap-6">
        <Link
          :href="home().url"
          class="font-semibold hover:underline"
          :class="{ underline: current('pages/home') }"
          >{{ t("navigation.home") }}</Link
        >
      </div>

      <div class="flex items-center gap-4">
        <LocaleSwitcher />
        <Link
          :href="sessions.destroy().url"
          method="delete"
          as="button"
          class="font-semibold hover:underline"
        >
          {{ t("navigation.sign_out") }}
        </Link>
      </div>
    </nav>
    <main class="p-6">
      <slot />
    </main>
  </div>
</template>
